module.exports = __webpack_public_path__ + "img/title_award.6d9e0323.png";